import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { LocalSeoKeywordsStatsCardsComponent } from './local-seo-keywords-stats-cards.component';
import { LocalSEOStatTabsComponent } from '../stat-tabs/stat-tabs.component';
import { ChartModule } from '@bit/vendasta.planets.chart';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { DeltaComponent } from '../delta/delta.component';
import { MatRipple } from '@angular/material/core';

@NgModule({
  declarations: [LocalSeoKeywordsStatsCardsComponent, LocalSEOStatTabsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatCardModule,
    ChartModule,
    MatIconModule,
    GalaxyTooltipModule,
    DeltaComponent,
    MatRipple,
  ],
  exports: [LocalSeoKeywordsStatsCardsComponent],
})
export class LocalSeoKeywordsStatsCardsModule {}
